export default {
      styleOverrides: {
        root: {
            color: 'var(--color-text)'
        },
      },
    }